import { apiUpdateItemsQuantity } from "Root/api/apiCheckout";
import { updateUserCart } from "Root/checkout/redux/slices/checkoutUserCartSlice";
import { useDispatch } from "react-redux";
const useQuantityUpdateHandler = ({ cart, setCart, setLineItems, setUpdatingPrice, userCart, setUserCart, }) => {
    const dispatch = useDispatch();
    const editQuantity = async (item_type, newQuantity) => {
        const cartCopy = { ...cart };
        cartCopy[item_type] = newQuantity;
        setCart(cartCopy);
        setUpdatingPrice(true);
        const userCartPayload = userCart.map((item) => item.item_type === item_type
            ? { sku: item.sku, quantity: newQuantity }
            : { sku: item.sku, quantity: item.quantity });
        const resp = await apiUpdateItemsQuantity(userCartPayload);
        setUserCart(resp.user_cart);
        dispatch(updateUserCart(resp.user_cart));
        setLineItems && setLineItems(resp.lineItems);
        setUpdatingPrice(false);
    };
    return editQuantity;
};
export default useQuantityUpdateHandler;
